<template lang='html'>
  <v-bottom-nav :value="true" app fixed>
    <v-btn v-for="lnk in links" v-if="lnk.path !== $route.path" :to="lnk.path" :key="`bottomLink${ lnk.path }`">
      <span>{{ lnk.name }}</span>
      <i :class="`icon-${ lnk.icon }`"/>
    </v-btn>

    <v-btn v-for="lnk in settingLinks" v-if="3 === 4 && $route.path === '/settings'" :key="`bottomSetting${ lnk.path }`" @click="lnk.action">
      <span>
        <span>{{ lnk.name.split(' ')[0] }}</span>
        <span class="hidden-xs-only">&nbsp;{{ lnk.name.split(' ')[1] }}</span>
      </span>
      <i :class="`icon-${ lnk.icon }`"/>
    </v-btn>
  </v-bottom-nav>
</template>

<script>
// import { mapGetters } from 'vuex';
export default {
  name: 'BottomNav',
  data() {
    return {
      links: [
        { name: "Home", path: "/", icon: "home" },
        { name: "Workouts", path: "/workouts", icon: "accessibility" },
        { name: "Kalendar", path: "/calendar", icon: "calendar" },
        { name: "Settings", path: "/settings", icon: "cogs" }
      ],
      settingLinks: [
        { name: "Reload Workouts", action: this.reloadData, icon: "cloud-download" },
        { name: "Reset Data", action: this.resetData, icon: "warning" }
      ]
    }
  },
}
</script>

<style lang='scss' scoped>

</style>